var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaneYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.086,
    height: 27.717,
    viewBox: "0 0 28.086 27.717",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1061",
    "data-name": "Groupe 1061",
    transform: "translate(296.203 354.923) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10407",
    "data-name": "Trac\\xE9 10407",
    d: "M271.039,334.19l-1.487,1.449L271,337.126l.669-.65.917,3.163-1.415,1.38,1.449,1.485.593-.577,1.125,4.122-4.691,4.572c-2,2.1-1.511,3.5-1.374,3.943h0l.079.082.071.073h0c.366.219,1.829.677,3.905-1.346l4.69-4.571,4.1,1.236-.594.579,1.446,1.484,1.415-1.38,3.22.93-.743.724,1.444,1.484,1.559-1.52,4.538,1.384,1.344-1.308-9.333-4.826-3.483-3.572.887-.863,5.973-7.122,6.372,1.041,1.045-1.159-5.474-2.788,2.084-2.032-.362-.371-2.086,2.031-2.79-5.547-1.042,1.015.8,6.324-7.2,5.858s-.368.358-.966.942l-3.477-3.569-4.577-9.462-1.334,1.3Z",
    fill: "#ffc43e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneYellow);
export default __webpack_public_path__ + "static/media/plane_yellow.0163af2d0ff37ee41e54bbcfd7478a5d.svg";
export { ForwardRef as ReactComponent };